import { ReactComponent as AgentIcon } from '@/assets/product/type/agent.svg';
import { ReactComponent as PDFIcon } from '@/assets/product/type/pdf.svg';
import { ReactComponent as PingjiaIcon } from '@/assets/product/type/pingjia.svg';
import { ReactComponent as QuickQAIcon } from '@/assets/product/type/quickqa.svg';

import { ReactComponent as ClinicalIcon } from '@/assets/product/qa_icon/CLINICAL.svg';
import { ReactComponent as EvidenceIcon } from '@/assets/product/qa_icon/EVIDENCE.svg';
import { ReactComponent as PopularScienceIcon } from '@/assets/product/qa_icon/POPULAR_SCIENCE.svg';
import { ReactComponent as ReportPPTIcon } from '@/assets/product/qa_icon/REPORT_PPT.svg';
import { ReactComponent as ResearchIcon } from '@/assets/product/qa_icon/RESEARCH.svg';

import { ReactComponent as Agent1Icon } from '@/assets/product/med_icon/med-agent1.svg';
import { ReactComponent as Agent2Icon } from '@/assets/product/med_icon/med-agent2.svg';
import { ReactComponent as Agent3Icon } from '@/assets/product/med_icon/med-agent3.svg';
import { ReactComponent as Agent4Icon } from '@/assets/product/med_icon/med-agent4.svg';

import { ReactComponent as PDFChatIcon } from '@/assets/product/pdf_tool/chat.svg';
import { ReactComponent as PDFSummaryIcon } from '@/assets/product/pdf_tool/ppt.svg';
import { ReactComponent as PDFTranslateIcon } from '@/assets/product/pdf_tool/translate.svg';

import { OriginPermission } from '@/utils/permission';

const getRouterPermission = (permission?: OriginPermission) => {
  return [
    {
      id: 'quickqa',
      name: 'product.quickqa.title',
      path: '/quickqa',
      icon: QuickQAIcon,
      disabled: permission && !permission?.PC_ROUTER_AI_SEARCH,
      hidden: false,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      children: [
        {
          id: 'EVIDENCE', // 证据快索
          icon: EvidenceIcon,
          style: {
            color: '#165DFF',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #F3F7FF 0%, #FFF 100%)',
          },
          name: 'product.quickqa.quicksearch.title',
          description: 'product.quickqa.quicksearch.description',
          placeholder: 'product.quickqa.quicksearch.placeholder',
          disabled: permission && !permission?.PC_MAIN_QUESTION_AND_ANSWER,
          hidden: false,
        },
        {
          id: 'RESEARCH', // 学术综述
          icon: ResearchIcon,
          style: {
            color: '#FF576D',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #FFF3F4 0%, #FFF 100%)',
          },
          name: 'product.quickqa.research.title',
          description: 'product.quickqa.research.description',
          placeholder: 'product.quickqa.research.placeholder',
          disabled: permission && !permission?.MULTIPLE_SUMMARIES_RESEARCH,
          hidden: false,
        },
        {
          id: 'CLINICAL',
          icon: ClinicalIcon,
          style: {
            color: '#1597A9',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #EDF9FA 0%, #FFF 100%)',
          },
          name: 'product.quickqa.clinical.title',
          description: 'product.quickqa.clinical.description',
          placeholder: 'product.quickqa.clinical.placeholder',
          disabled: permission && !permission?.MULTIPLE_SUMMARIES_CLINICAL,
          hidden: false,
        },
        {
          id: 'POPULAR_SCIENCE',
          icon: PopularScienceIcon,
          style: {
            color: '#8B60D5',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #F8F4FF 0%, #FFF 100%)',
          },
          name: 'product.quickqa.popular_science.title',
          description: 'product.quickqa.popular_science.description',
          placeholder: 'product.quickqa.popular_science.placeholder',
          disabled:
            permission && !permission?.MULTIPLE_SUMMARIES_POPULAR_SCIENCE,
          hidden: false,
        },
        {
          id: 'REPORT_PPT',
          icon: ReportPPTIcon,
          style: {
            color: '#DB983C',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #FFFAF4 0%, #FFF 100%)',
          },
          name: 'product.quickqa.report_ppt.title',
          description: 'product.quickqa.report_ppt.description',
          placeholder: 'product.quickqa.report_ppt.placeholder',
          disabled: permission && !permission?.PC_SPECIAL_REPORT,
          hidden: false,
        },
      ],
    },
    {
      id: 'med_agent',
      name: 'product.medagent.title',
      path: '/med-agent',
      icon: AgentIcon,
      disabled: false,
      hidden: false,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      children: [
        {
          id: 'fc799ca074744288a823a49318725e20',
          icon: Agent2Icon,
          name: 'product.medagent.wajue.title',
          placeholder: 'product.medagent.wajue.placeholder',
          description: 'product.medagent.wajue.description',
          // disabled: permission && !permission?.PC_ROUTER_DOMAIN_MANAGE,
          disabled: false,
          hidden: !permission?.PC_ROUTER_DOMAIN_MANAGE,
          cases: [
            {
              id: '539897f65efc4e0d8e78a3674af1f3de',
              title: 'MSS/pMMR型CRC的治疗',
            },
            {
              id: '46c9abd00c9049eda2d37278f3bdd76b',
              title: '推动MDS治疗的个体化生物标志物',
            },
            {
              id: 'c29b043c35bb4a3e8cd4c72783787614',
              title: '空间转录组学在肝细胞癌中的研究',
            },
          ],
        },
        {
          id: 'ef7cc2b36f8c45a89ef433e537d89040',
          icon: Agent4Icon,
          name: 'product.medagent.chuangxinfangan.title',
          placeholder: 'product.medagent.chuangxinfangan.placeholder',
          description: 'product.medagent.chuangxinfangan.description',
          disabled: false,
          // disabled: permission && !permission?.PC_ROUTER_INNOVATION_MANAGE,
          cases: [
            {
              id: '55ff1ba4885d43a9af80bd0b49c9d70e',
              title:
                '外泌体miRNA表达谱的多组学液体活检特征如何在 I-III期MSS/pMMR型CRC患者术后影响微小残留病灶（MRD）的早期检测与复发风险的精准预测',
            },
            {
              id: '16f05854df844afa8568cc86398b03e4',
              title: '造血干细胞（HSCs）免疫表型异常在MDS疾病进展中的机制',
            },
            {
              id: '0fd67e0988a54e49bec01203baad3e5a',
              title: 'MDS中NPM1突变作为治疗预测标志物的潜力',
            },
          ],
          hidden: !permission?.PC_ROUTER_INNOVATION_MANAGE,
        },
        {
          id: 'e46e9a15d0a3478a9deced4dbca93f6a',
          icon: Agent1Icon,
          name: 'product.medagent.daniu.title',
          placeholder: 'product.medagent.daniu.placeholder',
          description: 'product.medagent.daniu.description',
          // disabled: permission && !permission?.PC_ROUTER_EXPERT_MANAGE,
          disabled: true,
          hidden: true,
          cases: [],
        },
        {
          id: '0f6f8d15bb5c4145b005fa0705e6fe63',
          icon: Agent3Icon,
          name: 'product.medagent.gaofen.title',
          placeholder: 'product.medagent.gaofen.placeholder',
          description: 'product.medagent.gaofen.description',
          // disabled: permission && !permission?.PC_ROUTER_EXPLORATION_MANAGE,
          disabled: true,
          hidden: true,
          cases: [],
        },
      ],
    },
    {
      id: 'case_manage',
      name: 'product.caseManage.title',
      path: '/case-manage',
      icon: AgentIcon,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      disabled: !permission || !permission.PC_ROUTER_CLINICAL_CASE_MANAGE,
      hidden: !permission || !permission.PC_ROUTER_CLINICAL_CASE_MANAGE,
      children: [],
    },
    {
      id: 'ppt_agent',
      name: 'product.medppt.title',
      path: '/ppt-agent',
      icon: AgentIcon,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      disabled: !permission || !permission.PC_ROUTER_MED_PPT_MANAGE,
      hidden: !permission || !permission.PC_ROUTER_MED_PPT_MANAGE,
      children: [],
    },
    {
      id: 'diagnostic_agent',
      name: 'product.diagnostic_agent.title',
      path: '/diagnostic-agent',
      icon: AgentIcon,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      disabled: !permission || !permission.PC_ROUTER_DIAGNOSIS_MANAGE,
      hidden: !permission || !permission.PC_ROUTER_DIAGNOSIS_MANAGE,
      children: [],
    },
    {
      id: 'pingjia',
      name: 'product.pingjia.title',
      path: '/slr',
      icon: PingjiaIcon,
      disabled: !permission?.PC_ROUTER_SLR,
      hidden: false,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      children: [],
    },
    {
      id: 'pdf',
      name: 'product.pdf.title',
      path: '/pdf-tool',
      icon: PDFIcon,
      // disabled: !permission.PC_ROUTER_CHAT_WITH_PAPER,
      hidden: false,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      children: [
        {
          id: 'CHAT',
          icon: PDFChatIcon,
          style: {
            color: '#FF5280',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #FFF1F5 0%, #FFF 100%), #FFF',
          },
          name: 'product.pdf.chat.title',
          description: 'product.pdf.chat.description',
          disabled: permission && !permission?.DETAILS_PAGE_CHAT,
          homeCardBg:
            'https://nullht-official-website.oss-cn-shanghai.aliyuncs.com/KNOWS_DOCTOR/NEW_MEDKNOWS/home_bg/pdf.png',
          hidden: false,
        },
        {
          id: 'TRANSLATE',
          icon: PDFTranslateIcon,
          style: {
            color: '#3478F6',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #F7FAFF 0%, #FFF 100%), #FFF',
          },
          name: 'product.pdf.translate.title',
          description: 'product.pdf.translate.description',
          disabled: permission && !permission?.PC_FULL_TEXT_TRANSLATION,
          homeCardBg:
            'https://nullht-official-website.oss-cn-shanghai.aliyuncs.com/KNOWS_DOCTOR/NEW_MEDKNOWS/home_bg/translate.png',
          hidden: false,
        },
        {
          id: 'REPORT_PPT',
          icon: PDFSummaryIcon,
          style: {
            color: '#DB983C',
            hoverBg:
              'radial-gradient(82.55% 100% at 50% 100%, #FFFAF4 0%, #FFF 100%), #FFF',
          },
          name: 'product.pdf.summary.title',
          description: 'product.pdf.summary.description',
          disabled: permission && !permission?.PC_DETAILS_PAGE_GENERATE_PPT,
          homeCardBg:
            'https://nullht-official-website.oss-cn-shanghai.aliyuncs.com/KNOWS_DOCTOR/NEW_MEDKNOWS/home_bg/ppt.png',
          hidden: false,
        },
      ],
    },

    {
      id: 'expert-workbench',
      name: 'product.expertWorkbench.title',
      path: '/expert-workbench',
      icon: PingjiaIcon,
      disabled: !permission?.PC_ROUTER_EXPERT_WORKBENCH_MANAGE,
      hidden: !permission?.PC_ROUTER_EXPERT_WORKBENCH_MANAGE,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      children: [],
    },

    {
      id: 'knowledge',
      name: 'menu.knowledge',
      path: '/knowledge',
      icon: PingjiaIcon,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      disabled: !permission || !permission.PC_ROUTER_KB_MANAGE,
      hidden: !permission || !permission.PC_ROUTER_KB_MANAGE,
      children: [],
    },
    {
      id: 'records',
      name: 'menu.records',
      path: '/records',
      icon: PingjiaIcon,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      disabled: !permission || !permission.PC_ROUTER_DATA_MANAGE,
      hidden: !permission || !permission.PC_ROUTER_DATA_MANAGE,
      children: [],
    },
    {
      id: 'admin',
      name: 'menu.admin',
      path: '/admin',
      icon: PingjiaIcon,
      style: {
        backgroundColor: 'rgba(207, 240, 248, 0.80)',
        color: '#165DFF',
      },
      disabled: !permission || !permission.PC_ROUTER_USER_MANAGE,
      hidden: !permission || !permission.PC_ROUTER_USER_MANAGE,
      children: [],
    },
  ].filter((item) => !item.hidden);
};

export default getRouterPermission;
